var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("div", { staticClass: "layoutTop" }),
        _vm._v(" "),
        _c(
          "b-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "10", "offset-md": "1" } },
                  [
                    this.capsule === "draft-edit"
                      ? _c(
                          "f7-list",
                          { staticClass: "draftTitle" },
                          [
                            _c(
                              "f7-list-item",
                              [
                                _c(
                                  "f7-label",
                                  {
                                    staticClass:
                                      "paymentsRequestSubOption formLabel formLabelPayment",
                                  },
                                  [
                                    _c("span", { staticClass: "color-red" }, [
                                      _vm._v("*"),
                                    ]),
                                    _vm._v(
                                      "\n                Draft name\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("f7-input", {
                                  staticClass: "paymentsRequestSubOption",
                                  attrs: {
                                    placeholder: "Draft name",
                                    type: "text",
                                  },
                                  model: {
                                    value: _vm.draftName,
                                    callback: function ($$v) {
                                      _vm.draftName = $$v
                                    },
                                    expression: "draftName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "10", "offset-md": "1" } },
                  [
                    _c("back-button", { attrs: { returnUrl: "/home/" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "panel21 panel-default" },
                      [
                        _c("div", { staticClass: "panel-heading" }, [
                          _c(
                            "div",
                            {
                              staticClass: "showLargeScreenOnly formTitleBlock",
                            },
                            [
                              _c(
                                "h4",
                                {
                                  staticClass:
                                    "content-block labelAccordionForm",
                                  style: { color: _vm.titleColor },
                                },
                                [
                                  _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../../assets/static/images/icons/inbox_out.png"),
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("modularLoan.new_ml_rqst")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "showSmallScreenOnly formTitleBlock",
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "content-block labelAccordionForm creationFormTitle",
                                  style: { color: _vm.titleColor },
                                },
                                [
                                  _c("img", {
                                    staticClass: "formIcon",
                                    attrs: {
                                      src: require("../../../assets/static/images/icons/inbox_out.png"),
                                    },
                                  }),
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("modularLoan.new_ml_rqst")
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "content-block italicMandatoryIndication",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("common.asterisk_obligation_label")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c(
                                  "form-accordion",
                                  {
                                    attrs: {
                                      title: _vm.$t("attachments.doc"),
                                      open: false,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group row justify-content-start",
                                      },
                                      [
                                        !_vm.demo
                                          ? _c(
                                              "b-col",
                                              [
                                                _c(
                                                  "b-form-group",
                                                  [
                                                    _c("b-form-radio-group", {
                                                      attrs: {
                                                        disabled: this.readonly,
                                                        options:
                                                          _vm.fileTypeSelect,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.fileIsFacturX,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.fileIsFacturX =
                                                            $$v
                                                        },
                                                        expression:
                                                          "fileIsFacturX",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.readonly &&
                                        _vm.typeFile === "1" &&
                                        !_vm.attachement
                                          ? _c(
                                              "div",
                                              { staticClass: "col-12" },
                                              [
                                                _c(
                                                  "f7-button",
                                                  {
                                                    staticClass:
                                                      "attachmentButton buttonAccordionForm longword-word generalBottomButton",
                                                    attrs: { round: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.openImportAttachment(
                                                          _vm.typeFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.fileIsFacturX
                                                            ? "Importer une Factur-X"
                                                            : _vm.$t(
                                                                "attachments.import_doc"
                                                              )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.readonly &&
                                        _vm.isSmartphoneOS &&
                                        _vm.hasCamera
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-12 scanbutton",
                                              },
                                              [
                                                _c(
                                                  "f7-button",
                                                  {
                                                    staticClass:
                                                      "attachmentButton buttonAccordionForm generalBottomButton",
                                                    attrs: { round: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.scanOrder(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "creation_forms.scn_ordr_form"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c("b-col", [
                                          _vm.typeFile === "1" &&
                                          _vm.attachementNameLabel ===
                                            _vm.$t("creation_forms.imprt_file")
                                            ? _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.attachementNameLabel,
                                                    expression:
                                                      "attachementNameLabel",
                                                  },
                                                ],
                                                staticClass:
                                                  "form-control inputAccordionForm",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: _vm.$t(
                                                    "creation_forms.slct_a_fl"
                                                  ),
                                                  readonly: "",
                                                  id: "application-file-input",
                                                  disabled: this.readonly,
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.attachementNameLabel,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.attachementNameLabel =
                                                      $event.target.value
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-between",
                                            },
                                            [
                                              _vm.typeFile === "1" &&
                                              _vm.attachementNameLabel !==
                                                _vm.$t(
                                                  "creation_forms.imprt_file"
                                                )
                                                ? _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        id: "application-file-input",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.attachementNameLabel,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.attachementNameLabel =
                                                            $$v
                                                        },
                                                        expression:
                                                          "attachementNameLabel",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.attachementNameLabel
                                                        ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _vm.typeFile === "1" &&
                                                  _vm.attachementNameLabel !==
                                                    _vm.$t(
                                                      "creation_forms.imprt_file"
                                                    )
                                                    ? _c("i", {
                                                        staticClass:
                                                          "icon fa fa-download mx-1",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.view(
                                                              _vm.attachmentId
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.typeFile === "1" &&
                                                  _vm.attachementNameLabel !==
                                                    _vm.$t(
                                                      "creation_forms.imprt_file"
                                                    )
                                                    ? _c("i", {
                                                        staticClass:
                                                          "icon fa fa-search mx-1",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.openDoc(
                                                              _vm.attachmentId
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.typeFile === "2"
                                            ? _c(
                                                "select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.attachmentId,
                                                      expression:
                                                        "attachmentId",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    id: "sel2",
                                                    readonly: "",
                                                  },
                                                  on: {
                                                    change: [
                                                      function ($event) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.attachmentId =
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                      },
                                                      function ($event) {
                                                        return _vm.cloudFileSel()
                                                      },
                                                    ],
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "option",
                                                    {
                                                      attrs: {
                                                        value: "",
                                                        default: "",
                                                        disabled: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            this
                                                              .hasCloudAttachments
                                                              ? _vm.$t(
                                                                  "creation_forms.slct_a_fl"
                                                                )
                                                              : _vm.$t(
                                                                  "attachments.no_document"
                                                                )
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._l(
                                                    _vm.cloudDocsPicker,
                                                    function (cloudDoc) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: cloudDoc.id,
                                                          domProps: {
                                                            value: cloudDoc.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                cloudDoc.name
                                                              )
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("input", {
                                            key: _vm.refreshImport,
                                            staticClass:
                                              "item-input hiddenElementAllSize local-file-input",
                                            attrs: {
                                              type: "file",
                                              accept: ".pdf",
                                            },
                                            on: { change: _vm.onFileChange },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "hiddenElementAllSize",
                                            attrs: { type: "text" },
                                          }),
                                          _vm._v(" "),
                                          _c("input", {
                                            staticClass: "hiddenElementAllSize",
                                            attrs: {
                                              type: "text",
                                              id: "recommendation-list-input",
                                            },
                                          }),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    typeof _vm.attachmentName !== "undefined" &&
                                    _vm.attachmentName !== ""
                                      ? _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c(
                                                  "form-write-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t("common.rfrnc"),
                                                      placeholderValue:
                                                        _vm.$t(
                                                          "common.rfrnc_desc"
                                                        ),
                                                      disabled: this.readonly,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.attachmentReference,
                                                      callback: function ($$v) {
                                                        _vm.attachmentReference =
                                                          $$v
                                                      },
                                                      expression:
                                                        "attachmentReference",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.readonly
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "form-group justify-content-right",
                                          },
                                          [
                                            _vm.isSmartphone
                                              ? _c(
                                                  "b-col",
                                                  {
                                                    attrs: {
                                                      md: "4",
                                                      "offset-md": "2",
                                                    },
                                                  },
                                                  [
                                                    _vm.hasAttachment
                                                      ? _c(
                                                          "f7-button",
                                                          {
                                                            staticClass:
                                                              "buttonAccordionForm attachmentButton generalBottomButton",
                                                            attrs: {
                                                              round: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.view(
                                                                  _vm.attachmentId
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "creation_forms.view_attchmnt"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "4" } },
                                              [
                                                typeof _vm.attachmentName !==
                                                  "undefined" &&
                                                _vm.attachmentName !== ""
                                                  ? _c(
                                                      "f7-button",
                                                      {
                                                        staticClass:
                                                          "attachmentButton generalBottomButton",
                                                        attrs: { round: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clearAttachement()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "creation_forms.clear_label"
                                                              )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.readonly && _vm.hasAttachment
                                      ? _c("div", { staticClass: "row" }, [
                                          _vm.isSmartphone
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 offset-md2",
                                                },
                                                [
                                                  _c(
                                                    "f7-button",
                                                    {
                                                      staticClass:
                                                        "buttonAccordionForm attachmentButton",
                                                      attrs: { round: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.view(
                                                            _vm.attachmentId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "creation_forms.view_attchmnt"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isSmartphone
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-4 offset-md2",
                                                },
                                                [
                                                  _c(
                                                    "f7-button",
                                                    {
                                                      staticClass:
                                                        "buttonAccordionForm attachmentButton",
                                                      staticStyle: {
                                                        width: "200px",
                                                      },
                                                      attrs: { round: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.view(
                                                            _vm.attachmentId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "creation_forms.dwnld_attchmnt"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t(
                                "common.formsSubTitle.item_info_DD"
                              ),
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-contact-dropdown-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        inputLabel: _vm.$t("common.nme"),
                                        placeholderValue:
                                          _vm.$t("common.debtor_name"),
                                        disabled: _vm.readonly,
                                        mandatoryErrorIndicator:
                                          _vm.beneficiaireError,
                                      },
                                      on: {
                                        "change-iban": function ($event) {
                                          _vm.recipientBankAccount = $event
                                        },
                                        "change-identifier": function ($event) {
                                          _vm.recipientEmail = $event
                                        },
                                        "change-zonecode": function ($event) {
                                          return _vm.handleChangeRecipientZoneCode(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.beneficiaire,
                                        callback: function ($$v) {
                                          _vm.beneficiaire = $$v
                                        },
                                        expression: "beneficiaire",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-write-group-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        disabled: _vm.readonly,
                                        inputLabel: _vm.$t("common.idtfr"),
                                        placeholderValue: _vm.$t(
                                          "creation_forms.debtor_email_siren"
                                        ),
                                        regexpErrorIndicator:
                                          _vm.recipientEmailRegexpError,
                                      },
                                      model: {
                                        value: _vm.recipientEmail,
                                        callback: function ($$v) {
                                          _vm.recipientEmail = $$v
                                        },
                                        expression: "recipientEmail",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-group col-sm-6" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.account_zone")
                                          ) +
                                          "\n                      "
                                      ),
                                      _c("span", { staticClass: "color-red" }, [
                                        _vm._v("* "),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.recipientZoneCode,
                                            expression: "recipientZoneCode",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "sel4",
                                          disabled: _vm.readonly,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.recipientZoneCode = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      _vm._l(_vm.countries, function (country) {
                                        return _c(
                                          "option",
                                          {
                                            key: country.id,
                                            attrs: {
                                              disabled:
                                                country.disabled ||
                                                (!_vm.canSelectOtherThanEuro &&
                                                  country.label !== "EUR"),
                                            },
                                            domProps: {
                                              value: country,
                                              selected: country.selected,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                       " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "zoneCodes." + country.label
                                                  )
                                                ) +
                                                "\n                      "
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.recipientZoneCode.accountLabel,
                                  function (accountLabel) {
                                    return _c(
                                      "div",
                                      {
                                        key: accountLabel,
                                        staticClass: "form-group col-sm-6",
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$t(
                                                  "bank_accounts.bank_account_singular"
                                                )
                                              ) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "color-red" },
                                            [_vm._v("* ")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.recipientZoneCode.values[
                                                  accountLabel
                                                ],
                                              expression:
                                                "recipientZoneCode.values[accountLabel]",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          class: {
                                            errorBorder:
                                              _vm.recipientZoneCode.errors[
                                                accountLabel
                                              ] === "missing" ||
                                              _vm.recipientZoneCode.errors[
                                                accountLabel
                                              ] === "incorrect",
                                          },
                                          attrs: {
                                            disabled: _vm.readonly,
                                            name: "identifier",
                                            type: "text",
                                            placeholder:
                                              _vm.$t("common.debtor_ibn"),
                                          },
                                          domProps: {
                                            value:
                                              _vm.recipientZoneCode.values[
                                                accountLabel
                                              ],
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.recipientZoneCode.values,
                                                accountLabel,
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.recipientZoneCode.errors[
                                          accountLabel
                                        ] === "missing"
                                          ? _c(
                                              "div",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "errors.is_mandatory",
                                                        {
                                                          mandatoryValue:
                                                            _vm.$t(
                                                              accountLabel
                                                            ),
                                                        }
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm.recipientZoneCode.errors[
                                              accountLabel
                                            ] === "incorrect"
                                          ? _c(
                                              "div",
                                              { staticStyle: { color: "red" } },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "errors.is_incorrect",
                                                        {
                                                          incorrectValue:
                                                            _vm.$t(
                                                              accountLabel
                                                            ),
                                                        }
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "showLargeScreenOnly" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "form-group", attrs: { md: "6" } },
                              [
                                _c("select-bank-account", {
                                  model: {
                                    value: _vm.creditorBank,
                                    callback: function ($$v) {
                                      _vm.creditorBank = $$v
                                    },
                                    expression: "creditorBank",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t(
                                "common.formsSubTitle.mod_loan_dtls"
                              ),
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-write-group-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        inputLabel: _vm.$t("common.rsn"),
                                        placeholderValue: _vm.$t("common.rsn"),
                                      },
                                      model: {
                                        value: _vm.remittanceInformation,
                                        callback: function ($$v) {
                                          _vm.remittanceInformation = $$v
                                        },
                                        expression: "remittanceInformation",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-write-group-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        inputType: "number",
                                        inputLabel: _vm.$t("common.amnt"),
                                        placeholderValue: _vm.$t("common.amnt"),
                                      },
                                      model: {
                                        value: _vm.amount,
                                        callback: function ($$v) {
                                          _vm.amount = $$v
                                        },
                                        expression: "amount",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-write-group-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        inputType: "date",
                                        disablePastDates: "",
                                        inputLabel: _vm.$t("common.date_label"),
                                        placeholderValue:
                                          _vm.$t("common.slct_date"),
                                      },
                                      model: {
                                        value: _vm.depositExecutionDate,
                                        callback: function ($$v) {
                                          _vm.depositExecutionDate = $$v
                                        },
                                        expression: "depositExecutionDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-write-group-label-input", {
                                      attrs: {
                                        isMandatory: "",
                                        inputType: "number",
                                        inputLabel: _vm.$t(
                                          "common.deposit_amnt_label"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.deposit_amnt_label"
                                        ),
                                      },
                                      model: {
                                        value: _vm.deposit,
                                        callback: function ($$v) {
                                          _vm.deposit = $$v
                                        },
                                        expression: "deposit",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.rulesEnabled ? _c("hr") : _vm._e(),
                        _vm._v(" "),
                        _vm.rulesEnabled
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("regles_metier.titles.rules"),
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.canAddInstallmentRules,
                                                  value: true,
                                                  "unchecked-value": false,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.getAllInstallmentRules()
                                                  },
                                                },
                                                model: {
                                                  value: _vm.hasRegles,
                                                  callback: function ($$v) {
                                                    _vm.hasRegles = $$v
                                                  },
                                                  expression: "hasRegles",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "regles_metier.add_installment_rules"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { sm: "6" } },
                                      [
                                        _c(
                                          "b-form-group",
                                          [
                                            _c(
                                              "b-form-checkbox",
                                              {
                                                attrs: {
                                                  disabled:
                                                    !_vm.canAddInstallmentRules,
                                                  value: true,
                                                  "unchecked-value": false,
                                                },
                                                model: {
                                                  value: _vm.negotiationAllowed,
                                                  callback: function ($$v) {
                                                    _vm.negotiationAllowed = $$v
                                                  },
                                                  expression:
                                                    "negotiationAllowed",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "regles_metier.allow_edit_installments_rules"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c("b-col", { attrs: { sm: "6" } }, [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.hasRegles,
                                              expression: "hasRegles",
                                            },
                                          ],
                                          staticClass: "form-group",
                                        },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "regles_metier.select_installment_template"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              staticClass: "form-control",
                                              on: {
                                                change: function ($event) {
                                                  return _vm.setInstallmentRules(
                                                    $event
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: { selected: "" },
                                                  domProps: { value: 0 },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "regles_metier.none_installment_template"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.allRules,
                                                function (rule) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: rule.idReglesMetier,
                                                      domProps: {
                                                        value:
                                                          rule.idReglesMetier,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            rule.nom +
                                                              " – [installments: " +
                                                              rule.nbEcheances
                                                                .min +
                                                              " - " +
                                                              rule.nbEcheances
                                                                .max +
                                                              "]"
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.hasRegles
                                  ? _c("regles-form", {
                                      attrs: {
                                        hideInfo: "",
                                        hideInterests: "",
                                        value: _vm.reglesMetier,
                                      },
                                      on: {
                                        input: function ($event) {
                                          _vm.reglesMetier = $event
                                        },
                                        "echeance-changed": function ($event) {
                                          return _vm.echeanceChanged($event)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rulesEnabled &&
                        _vm.reglesMetier.idReglesMetier &&
                        _vm.hasRegles
                          ? _c("hr")
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.rulesEnabled &&
                        _vm.reglesMetier.idReglesMetier &&
                        _vm.hasRegles
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t(
                                    "regles_metier.titles.rules_details"
                                  ),
                                },
                              },
                              [
                                _vm.reglesMetier.idReglesMetier && _vm.hasRegles
                                  ? _c("regles-details", {
                                      attrs: { reglesMetier: _vm.reglesMetier },
                                    })
                                  : _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "regles_metier.details.no_rules"
                                          )
                                        )
                                      ),
                                    ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t(
                                "regles_metier.titles.installments"
                              ),
                            },
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          value: true,
                                          "unchecked-value": false,
                                          disabled:
                                            _vm.reglesMetier.nbEcheances.min >
                                            _vm.reglesMetier.nbEcheances.max,
                                        },
                                        model: {
                                          value: _vm.hasInstallments,
                                          callback: function ($$v) {
                                            _vm.hasInstallments = $$v
                                          },
                                          expression: "hasInstallments",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "regles_metier.add_installments"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          value: true,
                                          "unchecked-value": false,
                                        },
                                        model: {
                                          value:
                                            _vm.modificationInstallmentsAllowed,
                                          callback: function ($$v) {
                                            _vm.modificationInstallmentsAllowed =
                                              $$v
                                          },
                                          expression:
                                            "modificationInstallmentsAllowed",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "regles_metier.edit_installments"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.hasInstallments
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "form-group",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c("label", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "regles_metier.select_nb_installments"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.hasRegles &&
                                        _vm.reglesMetier.idReglesMetier
                                          ? _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.payNumber,
                                                    expression: "payNumber",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  disabled:
                                                    !_vm.hasInstallments,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.payNumber = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.$R.range(
                                                  parseInt(
                                                    _vm.reglesMetier.nbEcheances
                                                      .min
                                                  ),
                                                  parseInt(
                                                    _vm.reglesMetier.nbEcheances
                                                      .max
                                                  ) + 1
                                                ),
                                                function (nb) {
                                                  return _c(
                                                    "option",
                                                    { domProps: { value: nb } },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(nb) +
                                                          "\n                    "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                min: "1",
                                                max: "24",
                                                disabled: !_vm.hasInstallments,
                                              },
                                              model: {
                                                value: _vm.payNumber,
                                                callback: function ($$v) {
                                                  _vm.payNumber = $$v
                                                },
                                                expression: "payNumber",
                                              },
                                            }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.hasInstallments
                              ? _c("echeancier", {
                                  attrs: {
                                    numPay: _vm.payNumber,
                                    min: _vm.borneInf,
                                    amount: _vm.amount,
                                    ccy: _vm.ccy,
                                    deposit: _vm.deposit,
                                  },
                                  model: {
                                    value: _vm.multPmts,
                                    callback: function ($$v) {
                                      _vm.multPmts = $$v
                                    },
                                    expression: "multPmts",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c("b-col", { attrs: { md: "3", "offset-md": "1" } }),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { md: "3", "offset-md": "4" } },
                  [
                    _c(
                      "f7-button",
                      {
                        staticClass: "button-action milkyBlockBlack",
                        on: { click: _vm.sendDirectDebit },
                      },
                      [
                        _c("f7-icon", { attrs: { fa: "paper-plane" } }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("creation_forms.snd_rqust")) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbarPageBottomBlank" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }